<template>
    <div class="container">
        <div style="margin-bottom: 10px;">
            <el-button size="mini" type="success" plain text @click="handleSubmit">更新</el-button>
            <el-upload class="upload-demo btn inline-block" name="upload_file" :on-success="uploadSuccess1"
                :show-file-list="false" action="https://dq-back.wzfire.com/upload_file" :headers="headers" :multiple="false"
                accept=".jpeg,.jpg,.png" :data="uploadData">
                <el-button type="primary" size="mini" plain text style="margin-bottom: 10px;">上传原图</el-button>
            </el-upload>
            <el-upload class="upload-demo btn inline-block" name="upload_file" :on-success="uploadSuccess2"
                :show-file-list="false" action="https://dq-back.wzfire.com/upload_file" :headers="headers" :multiple="false"
                accept=".jpeg,.jpg,.png" :data="uploadData">
                <el-button type="primary" size="mini" plain text style="margin-bottom: 10px;">上传分析图</el-button>
            </el-upload>
            <el-select v-model="currentPage" @change="handleChange" placeholder="请选择页数" size="mini"
                style="margin-left: 15px;">
                <el-option v-for="item in pages" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div>
        <el-form style="margin: 0" ref="form" :model="form" :inline="true" size="mini">
            <table>
                <tr>
                    <td colspan="9" style="text-align: center">3.1.1复检检测结果/数据</td>
                </tr>
                <tr>
                    <td>环境温度（℃）</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_hjwd"></el-input>
                    </td>
                    <td>环境湿度（%RH）</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_hjsd"></el-input>
                    </td>
                    <td>风速（m/s）</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_fs"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>辐射系数</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_fsxs"></el-input>
                    </td>
                    <td>额定电压（V）</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_eddy"></el-input>
                    </td>
                    <td>额定电流（A）</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_eddl"></el-input>
                    </td>
                </tr>
                <tr>
                    <td><span style="color: red">被检测设备位置</span></td>
                    <td colspan="2">
                        <el-input v-model="form.bjcsbwz" disabled></el-input>
                    </td>
                    <td><span style="color: red">被检测设备名称</span></td>
                    <td colspan="2">
                        <el-input v-model="form.fj_bjcsbmc"></el-input>
                    </td>
                    <td>型号规格</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_xhgg"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>电压值（V）</td>
                    <td>A-B</td>
                    <td>
                        <el-input v-model="form.fj_dy_ab"></el-input>
                    </td>
                    <td>A-C</td>
                    <td>
                        <el-input v-model="form.fj_dy_ac"></el-input>
                    </td>
                    <td>B-C</td>
                    <td>
                        <el-input v-model="form.fj_dy_bc"></el-input>
                    </td>
                    <td>L-N</td>
                    <td>
                        <el-input v-model="form.fj_dy_ln"></el-input>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" style="text-align: center">数据/位置</td>
                    <td colspan="2">A相</td>
                    <td colspan="2">B相</td>
                    <td>C相</td>
                    <td>零线</td>
                </tr>
                <tr>
                    <td rowspan="2" style="text-align: center">实测温度（℃）</td>
                    <td colspan="2" style="text-align: center">进线</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_a_in"></el-input>
                    </td>
                    <td colspan="2">
                        <el-input v-model="form.fj_b_in"></el-input>
                    </td>
                    <td>
                        <el-input v-model="form.fj_c_in"></el-input>
                    </td>
                    <td>
                        <el-input v-model="form.fj_zero_in"></el-input>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="text-align: center">出线</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_a_out"></el-input>
                    </td>
                    <td colspan="2">
                        <el-input v-model="form.fj_b_out"></el-input>
                    </td>
                    <td>
                        <el-input v-model="form.fj_c_out"></el-input>
                    </td>
                    <td>
                        <el-input v-model="form.fj_zero_out"></el-input>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" style="text-align: center">负荷电流（A）</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_a_dl"></el-input>
                    </td>
                    <td colspan="2">
                        <el-input v-model="form.fj_b_dl"></el-input>
                    </td>
                    <td>
                        <el-input v-model="form.fj_c_dl"></el-input>
                    </td>
                    <td>
                        <el-input v-model="form.fj_zero_dl"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>温升（K）</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_ws"></el-input>
                    </td>
                    <td>相对温差（%）</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_xdwc"></el-input>
                    </td>
                    <td>图像编号</td>
                    <td colspan="2">
                        <el-input v-model="form.fj_txbh"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>复检检测结果</td>
                    <td colspan="4">
                        <el-select v-model="form.fj_jcjg" clearable placeholder="请选择结论" style="width: 100%;">
                            <el-option label="符合要求" value="符合要求"></el-option>
                            <el-option label="温度存在紧急缺陷" value="温度存在紧急缺陷"></el-option>
                            <el-option label="温度存在严重缺陷" value="温度存在严重缺陷"></el-option>
                            <el-option label="温度存在一般缺陷" value="温度存在一般缺陷"></el-option>
                        </el-select>
                    </td>
                    <td colspan="2">
                        隐患等级
                    </td>
                    <td colspan="2">
                        {{ fj_level }}
                    </td>
                </tr>
                <tr>
                    <td colspan="5" style="height: 50px; width: 50px; overflow: hidden;">
                        <el-image v-if="fj_image1_url" :src="fj_image1_url"
                            style="max-width: 100%; max-height: 100%; object-fit: contain;">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </td>
                    <td colspan="5" style="height: 50px; width: 50px; overflow: hidden;">
                        <el-image v-if="fj_image2_url" :src="fj_image2_url"
                            style="max-width: 100%; max-height: 100%; object-fit: contain;">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </td>
                </tr>
                <tr>
                    <td>备注</td>
                    <td colspan="8">相对温差：δ=(T1-T2)/(T1-T0)
                        ×100%，式中：T1—发热点的温升和温度；T2—正常相对应点的温升和温度；T0—被测设备区域的环境温度—气温。
                    </td>
                </tr>
            </table>
        </el-form>
    </div>
</template>

<script>

export default {
    name: "HwOne",
    props: {
        projectId: {
            type: String,
            required: true
        },
        siteId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            headers: { Authorization: this.$Config.userinfo.token },
            ids: [],
            pages: [],
            currentPage: '',
            form: {
                fj_hjwd: '',
                fj_hjsd: '',
                fj_fs: '',
                fj_fsxs: '',
                fj_eddy: '',
                fj_eddl: '',
                bjcsbwz: '',
                fj_bjcsbmc: '',
                fj_xhgg: '',
                fj_dy_ab: '',
                fj_dy_ac: '',
                fj_dy_bc: '',
                fj_dy_ln: '',
                fj_a_in: '',
                fj_a_out: '',
                fj_a_dl: '',
                fj_b_in: '',
                fj_b_out: '',
                fj_b_dl: '',
                fj_c_in: '',
                fj_c_out: '',
                fj_c_dl: '',
                fj_zero_in: '',
                fj_zero_out: '',
                fj_zero_dl: '',
                fj_ws: '',
                fj_xdwc: '',
                fj_txbh: '',
                fj_image1_id: '',
                fj_image2_id: '',
            },
            fj_image1_url: '',
            fj_image2_url: '',
        }
    },
    methods: {
        //更新
        async handleSubmit() {
            try {
                let params = this.form
                params.project_id = this.projectId
                params.site_id = this.siteId
                params.fj_level = this.fj_level
                await this.$Api.post('update_hw1', params)
                this.$message.success('更新成功')
            } catch (e) {
                this.$message.error(e.errormsg)
            }
        },
        //上传成功原图
        async uploadSuccess1(response, file, fileList) {
            this.form.fj_image1_id = response.data.file_id
            await this.handleSubmit()
            this.$message.success("上传成功");
            await this.getData()
        },
        //上传成功红外图
        async uploadSuccess2(response, file, fileList) {
            this.form.fj_image2_id = response.data.file_id
            await this.handleSubmit()
            this.$message.success("上传成功");
            await this.getData()
        },
        //获取所有页码
        async setPages() {
            try {
                let params = {
                    project_id: this.projectId,
                    site_id: this.siteId
                }
                let res = await this.$Api.post('get_hw1_pages', params)
                if (res) {
                    // 使用返回的 ids 设置页码
                    this.ids = res.ids.split(',')
                    this.pages = this.ids.map((id, index) => ({
                        value: index + 1,
                        label: index + 1
                    }))
                    this.currentPage = this.pages[0].value
                    // 获取第一条数据
                    if (this.ids.length > 0) {
                        this.getData(this.ids[0])
                    }
                }
            } catch (e) {
                this.$message.error(e.errormsg)
            }
        },
        //获取原始记录
        async getData() {
            let id = this.ids[this.currentPage - 1]

            try {
                let params = {
                    id: id
                }
                let res = await this.$Api.post('get_hw1', params)
                if (res) {
                    this.fj_image1_url = res.fj_image1_url
                    this.fj_image2_url = res.fj_image2_url
                    delete res.fj_image1_url
                    delete res.fj_image2_url
                    this.form = res
                }
            } catch (e) {
                this.$message.error(e.errormsg)
            }
        },
        //切页
        handleChange() {
            this.getData()
        },
    },
    computed: {
        fj_level() {
            if (this.form.fj_jcjg === '温度存在紧急缺陷') {
                return 'A';
            } else if (this.form.fj_jcjg === '温度存在严重缺陷') {
                return 'B'
            } else if (this.form.fj_jcjg === '温度存在一般缺陷') {
                return 'C'
            } else {
                return '--'
            }
        },
        uploadData() {
            return {
                project_id: this.projectId,
                site_id: this.siteId
            }
        }
    },
    created() {
        this.setPages()
    },
};
</script>

<style scoped>
table {
    width: 100%;
}

.inline-block {
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
}

table,
table tr td {
    border: 1px solid black;
    border-collapse: collapse;
    text-align: center;
    vertical-align: middle !important;
}
</style>